const buildQualtricsScriptSrc = (qualtricsId: string) => {
  const hostId = qualtricsId.toLowerCase().replace(/_/g, '');
  return `https://${hostId}-mercedesbenz.siteintercept.qualtrics.com/SIE/?Q_ZID=${qualtricsId}`;
};

export const QUALTRICS_DIV_ID = 'ZN_SV34BdRhWeacsj7';
export const QUALTRICS_SCRIPT_SRC = buildQualtricsScriptSrc(QUALTRICS_DIV_ID);

export const QUALTRICS_DIV_ID_NONPROD = 'ZN_3oMWcFe8QJVXj9h';
export const QUALTRICS_SCRIPT_SRC_NONPROD = buildQualtricsScriptSrc(QUALTRICS_DIV_ID_NONPROD);

export const QUALTRICS_DEFAULT_BRAND = 'MB';
export const QUALTRICS_BRAND_ATTRIBUTE = 'data-brand';

export const TENANT = 'seamless';
export const COMPONENT_NAME = 'seamless-qualtrics';

export const CONSENT_CONNECTION_NAME = 'ConsentContextConnection';
export const QUALTRICS_CONSENT_NAME = 'Qualtrics';

export const BRAND_CONTEXT_CONNECTION_NAME = 'BrandContextConnection';
export const PAGE_CONNECTION_NAME = 'PageConnection';

export const GLOBAL_CONTEXT_KEY = '__GLOBAL_CONTEXT__';
